/* eslint-disable import/prefer-default-export */
export { default as BlockquoteElement } from './BlockquoteElement';
